export default "__VITE_ASSET__Di1bCVtT__"